var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex flex-column" }, [
    _c(
      "h4",
      [
        _vm.listDisplay
          ? [
              _vm.languageDisplay
                ? _c("router-link", { attrs: { to: _vm.talkUrl() } }, [
                    _vm._v(
                      _vm._s(_vm.talk.title) +
                        " (" +
                        _vm._s(_vm.talk.language) +
                        ")"
                    ),
                  ])
                : _c("router-link", { attrs: { to: _vm.talkUrl() } }, [
                    _vm._v(_vm._s(_vm.talk.title)),
                  ]),
            ]
          : [
              _vm.languageDisplay
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.talk.title) +
                        " (" +
                        _vm._s(_vm.talk.language) +
                        ")"
                    ),
                  ])
                : _c("span", [_vm._v(_vm._s(_vm.talk.title))]),
            ],
        _vm._v(" "),
        _vm.userHasPermission
          ? _c("favorite", {
              attrs: {
                attr: "session",
                value: _vm.talk.content_code,
                obj: _vm.talk,
                "extra-css": "p-2",
              },
              on: {
                "favorite-changed": function ($event) {
                  return _vm.$emit("favorite-changed", $event)
                },
              },
            })
          : _c("i", {
              staticClass: "far fa-bookmark text-warning p-2",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.showRegisterAlert = !_vm.showRegisterAlert
                },
              },
            }),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col col-6" }, [
        _vm.showRegisterAlert
          ? _c(
              "div",
              { staticClass: "alert alert-danger" },
              [
                _vm.userIsLoggedIn
                  ? [
                      _vm.talk.ticket_shop_url
                        ? [
                            _vm._v(
                              "\n            Sie müssen sich für den Vortrag "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.talk.ticket_shop_url,
                                  target: "_blank",
                                },
                              },
                              [_vm._v("registrieren")]
                            ),
                            _vm._v("!\n          "),
                          ]
                        : [
                            _vm._v(
                              "\n            Die Registrierung ist in Kürze verfügbar!\n          "
                            ),
                          ],
                    ]
                  : [
                      _vm._v("\n            Sie müssen für den Vortrag "),
                      _c("a", { attrs: { href: "/accounts/login" } }, [
                        _vm._v("anmeldet"),
                      ]),
                      _vm._v("  (logged in) sein!\n        "),
                    ],
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "badge bg-secondary text-dark" }, [
          _c(
            "div",
            {
              staticClass: "font-weight-bold mb-0",
              staticStyle: { "font-size": "larger" },
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.parseDate(_vm.talk.start_datetime)) +
                  " • " +
                  _vm._s(_vm.displayTime(_vm.talk.start_datetime)) +
                  " - " +
                  _vm._s(_vm.displayTime(_vm.talk.end_datetime)) +
                  "\n        "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col col-4" }, [
        _c(
          "div",
          {
            staticClass: "font-weight-bold mb-0",
            staticStyle: { "font-size": "larger" },
          },
          [_vm._v("\n        " + _vm._s(_vm.talk.location.name) + "\n      ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col col-2 text-end" }, [
        _vm.listDisplay &&
        (_vm.talk.description ||
          (_vm.talk.speakers && _vm.talk.speakers.length))
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.talkExpanded = !_vm.talkExpanded
                  },
                },
              },
              [
                _vm.talkExpanded
                  ? _c("i", { staticClass: "fas fa-chevron-down" })
                  : _c("i", { staticClass: "fas fa-chevron-right" }),
              ]
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm.talk.description
      ? _c(
          "div",
          { staticClass: "my-2", class: { "two-lines": !_vm.talkExpanded } },
          [
            _c("span", {
              staticClass: "overflow-ellipsis",
              domProps: { innerHTML: _vm._s(_vm.talk.description) },
            }),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.talkExpanded
      ? _c(
          "div",
          {
            staticClass: "d-flex my-3",
            staticStyle: {
              "flex-direction": "row",
              gap: "16px",
              "flex-wrap": "wrap",
            },
          },
          [
            _vm._l(_vm.talk.speakers, function (speaker) {
              return _c("speaker-thumb", {
                key: speaker.id,
                attrs: { speaker: speaker },
                on: {
                  "speaker-click": function ($event) {
                    return _vm.$emit("speaker-click", $event)
                  },
                },
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.talk.chair_persons, function (chair) {
              return _c("speaker-thumb", {
                key: chair.id,
                attrs: { speaker: chair, "is-moderator": true },
                on: {
                  "speaker-click": function ($event) {
                    return _vm.$emit("speaker-click", $event)
                  },
                },
              })
            }),
            _vm._v(" "),
            _vm.talk.related_image
              ? _c(
                  "div",
                  {
                    staticClass: "d-flex flex-column align-items-center",
                    staticStyle: { gap: "15px" },
                  },
                  [
                    _c("img", {
                      staticStyle: { "object-fit": "cover" },
                      attrs: {
                        width: "100",
                        height: "60",
                        src: _vm.talk.related_image,
                      },
                    }),
                    _vm._v(" "),
                    _c("div", [_vm._v("Session-Sponsor")]),
                  ]
                )
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex flex-wrap", staticStyle: { gap: "0.25rem" } },
      _vm._l(_vm.talk.streams, function (stream) {
        return _c("div", { key: stream.id }, [
          _c(
            "a",
            {
              staticClass: "badge bg-primary",
              attrs: { href: "" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.$emit("stream", stream)
                },
              },
            },
            [_vm._v("\n        " + _vm._s(stream.name) + "\n      ")]
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }